// extracted by mini-css-extract-plugin
export var errorIcon = "_jw-1";
export var nameLogo = "_jw-0";